import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalErrorComponent } from '../../sections/modal-error/modal-error.component';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  constructor(private modalService: NgbModal) { }

  formatErrors(error: any) {
    let errorList: string[] = [];

    Object.getOwnPropertyNames(error).forEach(function (errorItem) {
      errorList = errorList.concat(error[errorItem]);
    });

    return errorList;
  }

  processResponseForErrors(response: any) {
    if (response.result) {
      return response.data;
    }
    else {
      const modalRef = this.modalService.open(ModalErrorComponent);
      modalRef.componentInstance.errors = response.errors;
      return null;
    }
  }

  showError(error: string) {
    const modalRef = this.modalService.open(ModalErrorComponent);
    modalRef.componentInstance.errors = [error];
  }

  showErrors(errors: any) {
    const modalRef = this.modalService.open(ModalErrorComponent);
    modalRef.componentInstance.errors = errors;
  }
}
